import RolesEnum from '../../Enum/RolesEnum';
import {
  getUser,
  isBackOfficeOrUpgasEmployee,
} from '../../services/UserService';
import ChatMenu from '../../components/sidebar/ChatMenu';
import { MenusFuncionarioEnum } from '../../Enum/MenuFuncionarioEnum';

const { BackOffice, FuncionarioUpgas, Organizacao } = RolesEnum;

const getMenus = (organizationResales) => {
  const { role } = getUser();
  const menus = [
    {
      key: '1',
      menuEnum: MenusFuncionarioEnum.Dashboard,
      url: '/dashboard',
      icon: 'chart-bar',
      text: 'Dashboard',
      roles: [BackOffice, FuncionarioUpgas, Organizacao],
      childs: [],
    },
    {
      key: '2',
      menuEnum: MenusFuncionarioEnum.Pedidos,
      url: '/dashboard/operacao',
      icon: 'cart-shopping',
      text: 'Pedidos',
      roles: [BackOffice, FuncionarioUpgas, Organizacao],
      childs: [],
    },
    {
      key: '4',
      menuEnum: MenusFuncionarioEnum.Revendas,
      url: isBackOfficeOrUpgasEmployee()
        ? '/revendas/list/1'
        : `/revendas/${organizationResales[0]?.id}/edit`,
      icon: isBackOfficeOrUpgasEmployee() ? 'storefront' : 'gear',
      text: isBackOfficeOrUpgasEmployee() ? 'Revendas' : 'Preços e Horários',
      roles: [BackOffice, FuncionarioUpgas, Organizacao],
      disabled: role === Organizacao && !organizationResales.length,
      childs: [],
    },
    {
      key: '19',
      menuEnum: MenusFuncionarioEnum.Organizacoes,
      url: '/organizacoes',
      icon: 'git-fork',
      text: 'Organizações',
      roles: [BackOffice, FuncionarioUpgas],
      childs: [],
    },
    {
      key: '18',
      menuEnum: MenusFuncionarioEnum.Financas,
      url: '',
      icon: 'dollar-sign',
      text: 'Finanças',
      roles: [BackOffice, FuncionarioUpgas, Organizacao],
      childs: [
        {
          key: '18.1',
          url: '/financas/pedidos',
          icon: 'container',
          text: 'Pedidos',
          roles: [BackOffice, FuncionarioUpgas, Organizacao],
          childs: [],
        },
        {
          key: '18.2',
          url: '/financas/balancos',
          icon: 'container',
          text: 'Balanços',
          roles: [BackOffice, FuncionarioUpgas, Organizacao],
          childs: [],
        },
      ],
    },
    {
      key: '5',
      menuEnum: MenusFuncionarioEnum.Pedidos,
      url: '/pedidos',
      icon: 'users',
      text: 'Histórico de Pedidos',
      roles: [Organizacao],
      childs: [],
    },
    {
      key: '13',
      menuEnum: MenusFuncionarioEnum.Relatorios,
      url: '',
      icon: 'table',
      text: 'Relatórios',
      roles: [BackOffice, FuncionarioUpgas],
      childs: [
        // {
        //   key: '14',
        //   url: '/relatorios/motoristas',
        //   icon: 'car',
        //   text: 'Relatório Motoristas',
        //   roles: [BackOffice, FuncionarioUpgas],
        //   childs: [],
        // },
        {
          key: '16',
          url: '/relatorios/revendas',
          icon: 'bank',
          text: 'Relatório Revendas',
          roles: [BackOffice, FuncionarioUpgas],
          childs: [],
        },
        {
          key: '17',
          url: '/relatorios/pedidos',
          icon: 'bank',
          text: 'Relatório Pedidos',
          roles: [BackOffice, FuncionarioUpgas],
          childs: [],
        },
      ],
    },
    {
      key: '12',
      menuEnum: MenusFuncionarioEnum.Configuracoes,
      url: '/configuracoes',
      icon: 'gear',
      text: 'Configurações',
      roles: [BackOffice, FuncionarioUpgas],
      childs: [],
    },
    {
      key: '8',
      url: '',
      icon: 'wrench',
      text: 'Gestão',
      roles: [BackOffice, FuncionarioUpgas],
      childs: [
        {
          key: '8.1',
          menuEnum: MenusFuncionarioEnum.Desempenho,
          url: '/desempenho',
          icon: 'chart-pie',
          text: 'Desempenho',
          roles: [BackOffice, FuncionarioUpgas],
          childs: [],
        },
        {
          key: '8.2',
          url: '/usuarios',
          icon: 'user',
          text: 'Usuários',
          roles: [BackOffice, FuncionarioUpgas],
          childs: [],
        },
        {
          key: '8.3',
          menuEnum: MenusFuncionarioEnum.Cupons,
          url: '/cupons',
          icon: 'tag',
          text: 'Cupons',
          roles: [BackOffice, FuncionarioUpgas],
          childs: [],
        },
        {
          key: '8.4',
          menuEnum: MenusFuncionarioEnum.QuadroDeAvisos,
          url: '/quadroDeAvisos',
          icon: 'megaphone',
          text: 'Quadros de Aviso',
          roles: [BackOffice, FuncionarioUpgas],
          childs: [],
        },
        {
          key: '8.5',
          menuEnum: MenusFuncionarioEnum.TelefonesBloqueados,
          url: '/telefonesBloqueados',
          icon: 'prohibit',
          text: 'Telefones Bloqueados',
          roles: [BackOffice, FuncionarioUpgas],
          childs: [],
        },
      ],
    },
    {
      key: '23',
      menuEnum: MenusFuncionarioEnum.Desempenho,
      url: '/desempenho',
      icon: 'chart-pie',
      text: 'Desempenho',
      roles: [Organizacao],
      childs: [],
    },
    {
      key: '7',
      url: '/motoristas',
      icon: 'truck',
      text: 'Motoristas',
      roles: [Organizacao],
      childs: [],
    },
    {
      key: '3',
      menuEnum: MenusFuncionarioEnum.Chat,
      url: '/chat',
      icon: 'comments',
      text: 'Chat',
      roles: [BackOffice, FuncionarioUpgas, Organizacao],
      childs: [],
      component: isBackOfficeOrUpgasEmployee() ? ChatMenu : null,
    },
    {
      key: '21',
      url: '/termos-condicoes',
      icon: 'boxes-stacked',
      text: 'Termos e Condições',
      roles: [Organizacao],
      childs: [],
    },
    {
      key: '25',
      menuEnum: MenusFuncionarioEnum.IndiqueGanhe,
      url: '/indiqueGanhe',
      icon: 'thumbs-up',
      text: 'Indique e Ganhe',
      roles: [BackOffice, FuncionarioUpgas],
      childs: [],
    },
  ];

  let menusResult = menus.filter((menu) =>
    menu.roles.some((menuRole) => menuRole === role),
  );

  menusResult
    .filter((menu) => menu.childs.length > 0)
    .forEach(
      (menu) =>
        (menu.childs = menu.childs.filter((child) =>
          child.roles.some((menuRole) => menuRole === role),
        )),
    );

  return menusResult;
};

export default getMenus;
